import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { BearerState, BearerStore } from '../../state/bearer.store';

@Injectable({
  providedIn: 'root'
})
export class BearerService extends Query<BearerState> {

  private bearer: string;
  private getBearer$ = this.select(state => state.bearer);

  constructor(protected bearerStore: BearerStore) {
    super(bearerStore);
    this.getBearer$
      .subscribe(bearer => {
        this.bearer = bearer;
      });
  }

  public getBearer(): string {
    return this.bearer;
  }

  setBearer(bearer: string) {
    this.bearerStore.setBearer(bearer);
    this.bearer = bearer;
  }

  resetBearer() {
    this.bearerStore.resetBearer();
  }

}
